import { BOOKING_STATUSES } from "@/static/bookingStatuses";
import { Expose } from "class-transformer";
import { IsBoolean, IsEnum, IsString } from "class-validator";

export class StatusCheckPartial {
  @IsString()
  @Expose()
  bookingItemTmpId!: string;
  @IsEnum(BOOKING_STATUSES)
  @Expose()
  availableBookingItemStatus!: BOOKING_STATUSES;
}

export class BookingItemStatusCheck extends StatusCheckPartial {
  @IsBoolean()
  @Expose()
  isAvailableStatusDifferentFromActualState!: boolean;
}

export type BookingStatusCheck = Array<StatusCheckPartial>;
